export default "__VITE_ASSET__BDWx1J$B__"